import { MERGE_SUCCESS_DEMANDES_LOCATAIRE } from "../actions/demandesLocataireAction";
import { LOAD_SUCCESS_REQUETES } from "../actions/requeteAction";
import { LOAD_SUCCESS_REQUETES_LOTS } from "../actions/requeteLotAction";
import { LOAD_SUCCESS_LOCATIONS } from "../actions/locationAction";
import { LOAD_SUCCESS_QUITTANCES } from "../actions/quittanceAction";
import { LOAD_SUCCESS_RENDUA } from "../actions/renduAction";

// Cache des locataires dont toutes les demandes sont fusionnées dans le store.
// Un rechargement complet d'une des slices concernées écrase la fusion : on invalide.
const initialState = {
  data: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case MERGE_SUCCESS_DEMANDES_LOCATAIRE:
      return {
        ...state,
        // Rechargement forcé d'un locataire déjà en cache : pas de doublon
        data: state.data.includes(action.payload.locataireId)
          ? state.data
          : [...state.data, action.payload.locataireId],
      };
    case LOAD_SUCCESS_REQUETES:
    case LOAD_SUCCESS_REQUETES_LOTS:
    case LOAD_SUCCESS_LOCATIONS:
    case LOAD_SUCCESS_QUITTANCES:
    case LOAD_SUCCESS_RENDUA:
      return initialState;
    default:
      return state;
  }
}
